import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import styled from 'styled-components';
import { css } from 'styled-components';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from 'react-share';

import { Lozenge } from '../components/Lozenge';
import { Meta } from '../components/Meta';
import facebook from '../assets/social/facebook.svg';
import twitter from '../assets/social/twitter.svg';
import linkedin from '../assets/social/linkedin.svg';
import SEO from '../components/SEO';
import { getExcerpt } from '../utils';

const PostWrapper = styled.div`
  max-width: 680px;
  margin-top: 60px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
`;

const LozengeWrapper = styled.div`
  text-align: center;
`;

const PostTitle = styled.h1`
  text-align: center;
  font-weight: 500;
  margin-top: 24px;
  margin-bottom: 24px;
`;

const PostMetaWrapper = styled.div`
  margin-bottom: 42px;
`;

const PostContent = styled.div`
  hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 11px 0;
    padding: 0; 
  }

  h1, h2 {
    font-size: 26px;
    line-height: 32px;
    font-weight: 500;
    margin-top: 42px;
    margin-bottom: 16px;
  }

  h3 {
    font-size: 22px;
    line-height: 28px;
    font-weight: 500;
    margin-top: 38px;
    margin-bottom: 14px;
  }

  p {
    color: #4f5a65;
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;
    margin-bottom: 32px;
  }

  a {
    color: #1f8ceb;
    text-decoration: none;
    transition: color .1s;
    &:hover {
      color: #b9dcfa;
    }
  }

  blockquote {

  }

  img {
    max-width: 100%;
  }
`;

const ShareButtonsWrapper = styled.div`
  position: fixed;
  @media (max-width: 767px) {
    background-color: white;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-top: 8px;
    padding-bottom: 8px;
    border-top: 1px solid #dde5ed;
    justify-content: space-around;
  }
  @media (min-width: 768px) {
    top: 20px;
    left: 20px;
    width: 36px;
    flex-direction: column;
  }
  display: ${props => props.display ? 'flex' : 'none'};
`;

const ShareButtonStyles = css`
  display: inline-flex;
  cursor: pointer;
  @media (min-width: 768px) {
    margin-bottom: 11px;
  }
`;

const FbShareButton = styled(FacebookShareButton)`
  ${ShareButtonStyles}
`;

const TwtrShareButton = styled(TwitterShareButton)`
  ${ShareButtonStyles}
`;

const LnkdShareButton = styled(LinkedinShareButton)`
  ${ShareButtonStyles}
`;

class BlogPostTemplate extends Component {

  constructor(props) {
    super(props);

    this.state = {
      scrollY: null,
      pastHeader: null,
    }

    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll(event) {
    this.setState({scrollY: window.scrollY})
    this.setState({pastHeader : window.scrollY > 58 ? true : false});
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const post = this.props.data.contentfulBlogPost;
    const siteMeta = this.props.data.site.siteMetadata;

    const shareUrl = `https://blog.helpfulpeeps.com${this.props.location.pathname}`;

    return (
      <PostWrapper>
        <SEO 
          title={post.title}
          description={getExcerpt(post.childContentfulBlogPostBodyTextNode.childMarkdownRemark.html)}
          url={shareUrl}
          image={siteMeta.image}
          twitter={siteMeta.twitter}
          postSEO
        />
        <LozengeWrapper>
          <Lozenge 
            type={post.category[0].slug}
          />
        </LozengeWrapper>
        <PostTitle>{post.title}</PostTitle>
        <PostMetaWrapper>
          <Meta 
            avatar={post.author[0].avatar.file.url}
            name={post.author[0].name}
            date={post.createdAt}
            align={'center'}
            size={'large'}
          />
        </PostMetaWrapper>
        <PostContent dangerouslySetInnerHTML={{ __html: post.childContentfulBlogPostBodyTextNode.childMarkdownRemark.html }} />
        <ShareButtonsWrapper 
          display={this.state.pastHeader}
        >
          <FbShareButton url={shareUrl}>
            <div style={{ backgroundColor: '#202F4E', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', width: 36, height: 36 }}>
              <svg style={{height: 18, width: 18, fill: '#FFF'}}>
                <use xlinkHref={`#${facebook.id}`} />
              </svg>
            </div>
          </FbShareButton>
          <TwtrShareButton url={shareUrl}>
            <div style={{ backgroundColor: '#202F4E', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', width: 36, height: 36 }}>
              <svg style={{height: 18, width: 18, fill: '#FFF'}}>
                <use xlinkHref={`#${twitter.id}`} />
              </svg>
            </div>
          </TwtrShareButton>
          <LnkdShareButton url={shareUrl}>
            <div style={{ backgroundColor: '#202F4E', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', width: 36, height: 36 }}>
              <svg style={{height: 18, width: 18, fill: '#FFF'}}>
                <use xlinkHref={`#${linkedin.id}`} />
              </svg>
            </div>
          </LnkdShareButton>
        </ShareButtonsWrapper>
      </PostWrapper>
    )
  }
}

export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostById($id: String!) {
    site {
      siteMetadata {
        image
        twitter
      }
    }
    contentfulBlogPost(id: { eq: $id }) {
      id
      title
      createdAt(formatString: "MMMM DD, YYYY")
      category {
        slug
      }
      author {
        name
        avatar {
          file {
            url
          }
        }
      }
      childContentfulBlogPostBodyTextNode {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog-post.js